import React from 'react';
import { Link } from 'react-router-dom';
import { useFailedMutations } from '../hooks/useFailedMutations';

const PendingIssuesBadge = ({ variant = 'header' }) => {
  const { mutations } = useFailedMutations();
  const count = mutations.length;
  if (count === 0) return null;

  if (variant === 'menu') {
    return (
      <Link
        to="/pending-issues"
        className="flex items-center px-4 py-2.5 text-sm text-body-text hover:bg-clay-bg transition-colors"
        aria-label={`${count} pending sync issues`}
      >
        <svg className="w-4 h-4 mr-3 text-fun-coral" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        Pending Issues
        <span className="badge-count ml-auto">{count}</span>
      </Link>
    );
  }

  return (
    <Link
      to="/pending-issues"
      className="relative p-1.5 text-fun-coral hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-clay transition-all duration-200"
      aria-label={`${count} pending sync issues`}
      title="Pending sync issues"
    >
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <span className="badge-count absolute -top-1 -right-1 badge-count-bounce">{count}</span>
    </Link>
  );
};

export default PendingIssuesBadge;
